import React, { useState, useEffect } from 'react';
import PlayerStoryGroupCard from './PlayerStoryGroupCard';
import { Col, Row, Button, Container } from 'react-bootstrap';
import ConfirmationDialog from '../../builder/common/ConfirmationDialog';

function PlayerStoryFrontPage({ stories, load }) {

    const [storyList, setStoryList] = useState([]);
    const [groupedStories, setGroupedStories] = useState(new Map());
    const [grouping, setGrouping] = useState(0);
    const [sorting, setSorting] = useState(1);
    const [approving, setApproving] = useState(-1);

    useEffect(() => {
        if (stories === undefined) {
            setStoryList([]);
        } else {
            setStoryList(stories);
        }

    }, [stories]);


    const addStory = (newGroupedStories, key, story) => {
        let storiesArray = [];
        if (!newGroupedStories.has(key)) {
            newGroupedStories.set(key, storiesArray);
        }
        else {
            storiesArray = newGroupedStories.get(key);
        }
        storiesArray.push(story);
    }

    const countStories = (story_owner) => {
        const count = storyList.reduce((acc, cur) => cur.story_owner === story_owner ? ++acc : acc, 0);
        return count;
    }

    useEffect(() => {
       // console.log('Sorting', sorting);
        let sortedList = storyList.sort((a, b) => {
            switch (sorting) {
                case 0:
                    if (grouping == 1)
                        return a.story_category.localeCompare(b.story_category);
                    else
                        return a.story_owner.localeCompare(b.story_owner);
                case 1:
                    return b.story_publishdate - a.story_publishdate;
                case 2:
                    return countStories(b.story_owner) - countStories(a.story_owner);
                default:
                    return b.name - a.name;

            }
        });

        let newGroupedStories = new Map();
        for (let storyIndex in sortedList) {
            let story = sortedList[storyIndex];


            let key = story.story_owner;
            switch (grouping) {
                case 0:
                    key = story.story_owner;
                    addStory(newGroupedStories, key, story);
                    break;
                case 1:
                    key = story.story_category;
                    if (key.length == 0) {
                        key = 'One off Stories';
                    }
                    addStory(newGroupedStories, key, story);
                    break;
                case 2:
                    //console.log(story);

                    if (story.story_labels.length == 0) {
                        addStory(newGroupedStories, 'untagged', story);
                    } else {

                        story.story_labels.forEach(label => {
                            key = label;
                            addStory(newGroupedStories, key, story);
                        });
                    }
                    break;
            }
        }
        setGroupedStories(newGroupedStories);
    }, [storyList, grouping, sorting]);

  //  console.log(groupedStories);

    let sk = [...groupedStories.keys()];

    const sortGroups = (groups) => {
//        console.log('keys', groups);

        if (sorting == 0) {

            return groups.sort((a, b) => {
                return a.localeCompare(b);

            });
        }
        else
            return groups;

    }
    sk = sortGroups(sk);
//    console.log(sk);


    const getGroupTitle = (storyKey) => {
        switch (grouping) {
            case 0:
                return storyKey + "'s tales";
            case 1:
                return storyKey;
            default:
                return storyKey;
        }
    }

    const approveStory = (story_id) => {
        console.log('Approve', story_id);
        setApproving(story_id);
    }

    const approveStoryId = (story_id) => {
        console.log('Approve Request', story_id);
        setApproving(-1);
    }


    return (<>
        <ConfirmationDialog title={`Approve Story ${approving}?`} show={approving > -1} cancelModal={() => setApproving(-1)}
            confirmModal={() => { approveStoryId() }} />
        <h2 className={"py-2"}>Stories, Categories and More</h2>
        <Row className={"py-2"}>
            <Col xxl={6}>
                <Row className={"justify-content-left"}>
                    <Col>
                        <h5>Group</h5>
                    </Col>
                    <Col >
                        <Button onClick={() => setGrouping(0)}>
                            By Author
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => setGrouping(1)}>
                            By Storyline
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => setGrouping(2)}>
                            By Category
                        </Button>
                    </Col>
                </Row>
            </Col>
            <Col xxl={6}>
                <Row className={"align-content-centre"}>
                    <Col>
                        <h5>Order</h5>
                    </Col>
                    <Col>
                        <Button onClick={() => setSorting(0)}>
                            Group A-Z
                        </Button>
                    </Col>

                    <Col>
                        <Button onClick={() => setSorting(1)}>
                            Most Recent
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => setSorting(2)}>
                            Most Prolific Author
                        </Button>
                    </Col>


                </Row>
            </Col>
        </Row>
        <Row>
            {sk.map((key, index) =>
                <PlayerStoryGroupCard key={index} title={getGroupTitle(key)} stories={groupedStories.get(key)} load={load} approveStory={approveStory} />
            )}
        </Row>
    </>);
}

export default PlayerStoryFrontPage;